<template>

    <div class="bundle-pricing-table-content-item" 
        @mouseover="showBlockActionButtons = true" 
        @mouseleave="showBlockActionButtons = false" >
        <div v-if="showBlockActionButtons" class="pt-delete" @click="deletePtItem(arrayIndex,curItem)">
            <i class="fas fa-times"></i>
        </div>
        <div v-if="showBlockActionButtons" class="block-drag-handle-pt-item">
            <i class="fas fa-ellipsis-h"></i>
        </div>
        <span v-if="globalSettings.elementGuidesOnlyDashboard">
            <i v-if="curTable.hideIcon" class="fas fa-check-circle check-icon-item"></i>
            <component v-html="curItem.name" v-model="curItem.name" class="pt-item-input" :is="span" contenteditable="true" @blur="updateItem(arrayIndex,curItemIndex)"></component>
        </span>
        <span v-if="!globalSettings.elementGuidesOnlyDashboard">
            <i v-if="curTable.hideIcon" class="fas fa-check-circle check-icon-item"></i>
            <span v-html="curItem.name" contenteditable="false"></span>
        </span>
    </div>

</template>

<script>
export default {

    props: ['curItem','arrayIndex','curTable','curItemIndex'],

    name: 'Pricingtableitem',

    data() {
        return {
            span: 'span',
            editable_dashboard: true,

            // show child block action buttons: settings + delete
            showBlockActionButtons: false,
            showChildSettings: false,

            confirmBlockDelete: false,

        }
    },

    methods: {
        deletePtItem(arrayIndex,curItem) {
            console.log(curItem)
            this.$store.state.weeblySettings.settings.tables[arrayIndex].items.splice(this.curItem, 1)
        },

        updateTitle(arrayIndex,curItemIndex) {
            // console.log(this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText)
            // this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText = event.target.innerText
        },

        updateItem(arrayIndex,curItemIndex) {
            console.log(event.target.textContent)
            this.$store.state.weeblySettings.settings.tables[arrayIndex].items[curItemIndex].name = event.target.innerHTML
        }

    },

    computed: {
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        }

    }

}
</script>

<style lang="less">
@import '../../../../less/colors.less';

.bundle-accordion-element {
    position: relative;
}
.access-settings-tooltip, .delete-block-tooltip {
    background: @action_blue;
    padding: 7px;
    font-weight: 700;
}

.delete-block-tooltip {
    background: @warning_red;
}
.confirm-block-deletion {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 350px;
    background: #fff;
    border: 1px solid @shark_light;
    z-index: 1000;
    font-size: 12px;
    border-radius: .25rem;
    text-align: center;
    box-shadow: 0 4px 10px fade(@shark_light, 25%);

    h4 {
        font-size: 20px;
        font-weight: 400;
        background: @shark_light;
        color: #fff;
        padding: 10px;
    }

    p {
        font-size: 13px;
        padding: 15px;
        margin: 0;
    }

    span {
        margin: 5px 5px 15px;
        display: inline-block;
        font-weight: 700;
        cursor: pointer;
        color: @text_grey;
        font-size: 13px;
        padding: 7px 12px;
        background: fade(@shark_light,12%);
        border-radius: .25rem;

        &:hover {
            opacity: .9;
        }

        i {
            margin-right: 7px;
        }
    }

    .confirm-delete-block-action {
        background: @warning_red;
        color: #fff;
    }
}

.block-drag-handle {
    position: absolute;
    top: -7px;
    left: 50%;
    height: 20px;
    width: 34px;
    margin-left: -17px;
    background: #fff;
    cursor: move;
    z-index: 10;
    border-radius: .25rem;
    text-align: center;
    border: 1px solid @action_blue;

    i {
        font-size: 10px;
        line-height: 20px;
        color: @action_blue;
    }
}

.settings-child-icon {
    position: absolute;
    top: -7px;
    left: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@action_blue, 85%);
    }
}

.delete-child-icon {
    z-index: 10;
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @warning_red;
    border-radius: .25rem;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    &:hover {
        background: fade(@warning_red, 85%);
    }
}

.sortable-chosen {
    opacity: .7;
    border: 1px solid @action_blue;
}
.ghost-block {
    background: @action_blue!important;
    opacity: .2;
}

input.div-like-input {
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 100%;
    outline: none!important;
    background: none;
    border: 0;
}

.bundle-pricing-table-content-item {
    position: relative;
}

.pt-delete {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-22px);
    cursor: pointer;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: .25rem;
    background: @warning_red;
    
    i {
        color: #fff;
        font-size: 12px;
    }
}

.block-drag-handle-pt-item {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(2px);
    cursor: move; 
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    
    i {
        color: #fff;
        font-size: 12px;
    }
}

input.div-like-input {
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 100%;
    outline: none!important;
    background: none;
    border: 0;
    max-width: 100%;
}

.pt-item-input:focus, .pt-item-input:active {
    outline: none!important;
}


</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/pricingtableelement/Pricingtableitem.vue